import { connect } from 'react-redux';
import PostOnboarding from './PostOnboarding';
import { myAccountSelector } from 'state/selectors/account';
import withTokenHandler from 'components/HOC/TokenHandlerHOC';

interface PostOnboardingState {
  accounts: any;
}

interface MapStateToProps {
  account: ReturnType<typeof myAccountSelector>;
}

const mapStateToProps = (state: PostOnboardingState): MapStateToProps => {
  return {
    account: myAccountSelector(state)
  };
};

export default connect(mapStateToProps)(withTokenHandler(PostOnboarding));
